exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n    color: #373a3c; \n}\n\nlabel { \n    display: inline-block;\n    width: 200px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/modules/modules.component.css
// module id = ../../../../../src/app/modules/modules.component.css
// module chunks = main